import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const PoliticaTratamientoDatos: React.FC = () => {
  const cooperativaInfo = {
    nombre: "Cooperativa Multiactiva del Magdalena y del Caribe",
    nit: "901558424-3",
    sigla: "COOPMULMAG",
    email: "coopmulmag@gmail.com",
    web: "www.coopmulmag.com.co"
  };

  return (
    <div className="politica-datos py-5">
      <Container>
        {/* Encabezado */}
        <Row className="mb-5">
          <Col className="text-center">
            <h1 className="display-5 fw-bold text-success mb-3">
              Política de Tratamiento de Datos Personales
            </h1>
            <div className="d-flex justify-content-center gap-3 text-muted">
              <span>{cooperativaInfo.nombre}</span>
              <span>NIT: {cooperativaInfo.nit}</span>
            </div>
          </Col>
        </Row>

        {/* Introducción */}
        <Card className="shadow-sm mb-4 border-success">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Introducción
            </Card.Title>
            <Card.Text>
              En cumplimiento de lo dispuesto en la Ley 1581 de 2012, el Decreto Reglamentario 1377 de 2013 y demás 
              normas concordantes, {cooperativaInfo.nombre} identificada con NIT {cooperativaInfo.nit}, en adelante 
              "{cooperativaInfo.sigla}", presenta su Política de Tratamiento de Datos Personales, con el objetivo de 
              garantizar la protección de los derechos de los titulares de la información y establecer los lineamientos 
              para la recolección, almacenamiento, uso, circulación y supresión de los datos personales.
            </Card.Text>
          </Card.Body>
        </Card>

        {/* Definiciones */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Definiciones
            </Card.Title>
            <Row>
              {definiciones.map((def, index) => (
                <Col md={6} key={index} className="mb-3">
                  <div className="d-flex">
                    <div>
                      <strong>{def.termino}:</strong> {def.definicion}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

        {/* Principios */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Principios para el Tratamiento de Datos Personales
            </Card.Title>
            <Row>
              {principios.map((principio, index) => (
                <Col md={6} key={index} className="mb-3">
                  <div className="d-flex">
                    <div>
                      <strong>{principio.nombre}:</strong> {principio.descripcion}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

        {/* Derechos de los Titulares */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Derechos de los Titulares de la Información
            </Card.Title>
            <ul className="list-unstyled">
              {derechosTitulares.map((derecho, index) => (
                <li key={index} className="mb-2">
                  {derecho}
                </li>
              ))}
            </ul>
          </Card.Body>
        </Card>

        {/* Finalidades del Tratamiento */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Finalidades del Tratamiento
            </Card.Title>
            <p className="fw-bold">Los datos personales serán tratados por {cooperativaInfo.sigla} para las siguientes finalidades:</p>
            <ul className="list-unstyled">
              {finalidades.map((finalidad, index) => (
                <li key={index} className="mb-2">
                  {finalidad}
                </li>
              ))}
            </ul>
          </Card.Body>
        </Card>

        {/* Área de Contacto */}
        <Card className="shadow-sm mb-4 border-success">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Ejercicio de los Derechos y Atención de Consultas y Reclamos
            </Card.Title>
            <Card.Text>
              Los titulares de la información pueden ejercer sus derechos de conocer, actualizar, rectificar, 
              suprimir información y revocar la autorización, mediante comunicación escrita dirigida a:
            </Card.Text>
            <Row className="mt-3">
              <Col md={6}>
                <Card className="bg-light border-0">
                  <Card.Body>
                    <h6 className="fw-bold">Responsable del Tratamiento:</h6>
                    <p className="mb-1">{cooperativaInfo.nombre}</p>
                    <p className="mb-1">NIT: {cooperativaInfo.nit}</p>
                    <p className="mb-1">Email: {cooperativaInfo.email}</p>
                    <p className="mb-0">Web: {cooperativaInfo.web}</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="bg-light border-0">
                  <Card.Body>
                    <h6 className="fw-bold">Oficina de Protección de Datos:</h6>
                    <p className="mb-1">Horario de atención: Lunes a Viernes de 8:00 am a 5:00 pm</p>
                    <p className="mb-1">Teléfono: 57 315 6851124</p>
                    <p className="mb-0">Dirección: Cl 14 27 195 CC Bastidas - Santa Marta - Magdalena</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Procedimiento para Consultas y Reclamos */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Procedimiento para Consultas y Reclamos
            </Card.Title>
            
            <h6 className="fw-bold mt-3">Consultas:</h6>
            <p>
              {cooperativaInfo.sigla} atenderá las consultas de los titulares dentro de los diez (10) días hábiles 
              siguientes a la fecha de recibo de la misma. Cuando no fuere posible atender la consulta dentro de dicho 
              término, se informará al interesado, expresando los motivos de la demora y señalando la fecha en que se 
              atenderá, que en ningún caso podrá superar los cinco (5) días hábiles siguientes al vencimiento del 
              primer término.
            </p>

            <h6 className="fw-bold mt-3">Reclamos:</h6>
            <p>
              El término para resolver las reclamaciones será de quince (15) días hábiles contados a partir del día 
              siguiente a la fecha de su recibo. Cuando no fuere posible atender el reclamo dentro de dicho término, 
              se informará al interesado los motivos de la demora y la fecha en que se atenderá, que en ningún caso 
              podrá superar los ocho (8) días hábiles siguientes al vencimiento del primer término.
            </p>
          </Card.Body>
        </Card>

        {/* Vigencia */}
        <Card className="shadow-sm mb-4">
          <Card.Body>
            <Card.Title className="text-success fw-bold mb-3">
              Vigencia
            </Card.Title>
            <Card.Text>
              La presente Política de Tratamiento de Datos Personales rige a partir del [fecha de aprobación] y 
              estará vigente durante el desarrollo del objeto social de {cooperativaInfo.sigla}. Los datos personales 
              se conservarán durante el tiempo razonable y necesario para cumplir las finalidades descritas en esta 
              política, conforme a las disposiciones legales aplicables.
            </Card.Text>
            <p className="fst-italic mt-3">
              Última actualización: {new Date().toLocaleDateString('es-CO', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </Card.Body>
        </Card>

        {/* Aceptación */}
        <Card className="shadow-sm border-success">
          <Card.Body className="text-center">
            <Card.Text className="mb-3">
              Al suministrar sus datos personales a {cooperativaInfo.nombre}, el titular manifiesta su aceptación 
              y autorización expresa para el tratamiento de sus datos personales conforme a la presente política.
            </Card.Text>
            <div className="border-top pt-3">
              <small className="text-muted">
                Para más información, consulte nuestra página web o contáctenos a través de nuestros canales de atención.
              </small>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

// Los arrays de datos estáticos se mantienen igual
const definiciones = [
  {
    termino: "Autorización",
    definicion: "Consentimiento previo, expreso e informado del Titular para llevar a cabo el Tratamiento de datos personales."
  },
  // ... resto de definiciones
  {
    termino: "Tratamiento",
    definicion: "Cualquier operación o conjunto de operaciones sobre datos personales, tales como recolección, almacenamiento, uso, circulación o supresión."
  }
];

const principios = [
  {
    nombre: "Legalidad",
    descripcion: "El Tratamiento se realiza conforme a la ley y demás disposiciones aplicables."
  },
  // ... resto de principios
  {
    nombre: "Confidencialidad",
    descripcion: "Todas las personas que intervengan en el Tratamiento de datos personales están obligadas a garantizar la confidencialidad."
  }
];

const derechosTitulares = [
  "Conocer, actualizar y rectificar sus datos personales frente a responsables o encargados del Tratamiento.",
  "Solicitar prueba de la autorización otorgada al responsable del Tratamiento.",
  "Ser informado por el responsable o encargado del Tratamiento, previa solicitud, respecto del uso que le ha dado a sus datos personales.",
  "Presentar quejas ante la Superintendencia de Industria y Comercio por infracciones a lo dispuesto en la normatividad vigente.",
  "Revocar la autorización y/o solicitar la supresión del dato cuando en el Tratamiento no se respeten los principios, derechos y garantías constitucionales y legales.",
  "Acceder en forma gratuita a sus datos personales que hayan sido objeto de Tratamiento."
];

const finalidades = [
  "Desarrollar el objeto social de la cooperativa y cumplir las obligaciones contractuales con asociados y clientes.",
  // ... resto de finalidades
  "Transferir y transmitir información a terceros encargados del tratamiento, nacionales o internacionales, para el cumplimiento de las finalidades descritas."
];

export default PoliticaTratamientoDatos;